import { ReactNode } from 'react'
import { clsx } from 'clsx'
import BPACLogo from '@/assets/images/BPAC-modified.png'

interface LayoutProps {
  children: ReactNode
}

export function Layout({ children }: LayoutProps) {
  return (
    <main className="min-h-screen py-8 px-4 sm:px-6 lg:px-8 bg-logo">
      <style>
        {`.bg-logo::before { background-image: url(${BPACLogo}); }`}
      </style>
      <div className="max-w-2xl mx-auto">
        {children}
      </div>
    </main>
  )
}

export function WizardHeader({ title, step, totalSteps }: { title: string; step?: number; totalSteps?: number }) {
  return (
    <div className="mb-8 text-center">
      <h1 className="text-3xl sm:text-4xl font-bold text-secondary-foreground mb-2">
        {title}
      </h1>
      {step !== undefined && totalSteps !== undefined && (
        <>
          <div className="flex items-center justify-center gap-2" aria-hidden="true">
            {Array.from({ length: totalSteps }, (_, i) => (
              <div
                key={i}
                className={clsx(
                  'h-2 rounded-full transition-all',
                  {
                    'w-8 bg-accent': i < step,
                    'w-4 bg-white border border-gray-300': i >= step,
                  }
                )}
              />
            ))}
          </div>
          <p className="text-sm text-gray-600 mt-2">
            Step {step} of {totalSteps}
          </p>
        </>
      )}
    </div>
  )
}
